import { Base } from './base.size';
import { SuperHero } from './super-hero.size';
import { H1 } from './h1.size';
import { H2 } from './h2.size';
import { H3 } from './h3.size';
import { H4 } from './h4.size';
import { H5 } from './h5.size';
import { H6 } from './h6.size';
import { Intro } from './intro.size';
import { Big } from './big.size';
import { Small } from './small.size';
import { ExtraSmall } from './extra-small.size';
import { PriceBig } from './price-big.size';
import { PriceMedium } from './price-medium.size';
import { PriceBase } from './price-base.size';
import { Input } from './input.size';
import { Button } from './button.size';
import { ButtonSmall } from './button-small.size';
import { Badge } from './badge.size';
export var sizes = {
  default: Base,
  p: Base,
  'super-hero': SuperHero,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  intro: Intro,
  big: Big,
  base: Base,
  small: Small,
  'extra-small': ExtraSmall,
  subline: Big,
  'price-big': PriceBig,
  'price-medium': PriceMedium,
  'price-base': PriceBase,
  input: Input,
  button: Button,
  'button-small': ButtonSmall,
  badge: Badge
};